import { Grid, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse/Collapse';
import { LedgerAccountKindMap } from '@work4all/components/lib/components/entity-picker/ledger-account-kind-picker/LedgerAccountKind.enum';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';
import { LabeledInput } from '@work4all/components/lib/input/labeled-input';

import { EnumPickerField } from '../../../../../../../components/entity-picker/EnumPickerField';
import { ControllerPlus } from '../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../form-plus/use-form-context-plus';
import { LedgerAccountFormValue } from '../../types';

export function LedgerAccountMaskContent() {
  const { t } = useTranslation();

  const { register, control, setValue } =
    useFormContextPlus<LedgerAccountFormValue>();

  const handleMinValue = (e, key) => {
    if (!e.target.value) {
      setValue(key, 0, { shouldDirty: true, shouldValidate: true });
    }
  };

  return (
    <Collapse title={t('COMMON.DESCRIPTION')} defaultOpen>
      <Grid container spacing="1rem">
        <Grid item xs={12} md={8}>
          <Grid container spacing="1rem">
            <Grid item xs={12} md={4}>
              <LabeledInput
                label={t('INPUTS.ACCOUNT_NUMBER')}
                {...register('number')}
                type="number"
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <LabeledInput label={t('COMMON.NAME')} {...register('name')} />
            </Grid>
            <Grid item xs={12} md={4}>
              <ControllerPlus
                control={control}
                name="kind"
                render={({ field }) => {
                  return (
                    <EnumPickerField
                      values={LedgerAccountKindMap}
                      label={t('COMMON.GENERAL_LEDGER_ACCOUNT_TYPE')}
                      translationPrefix="GENERAL_LEDGER_ACCOUNT_TYPE"
                      {...field}
                      onChange={(e) => {
                        field.onChange(Number(e));
                      }}
                    />
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <LabeledInput
                label={t('COMMON.ACCOUNT_GROUP')}
                {...register('accountGroup')}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <LabeledInput
                label={t('COMMON.TAX_KEY_long')}
                {...register('taxKeyValue')}
                onBlur={(e) => handleMinValue(e, 'taxKeyValue')}
                type="number"
                selectOnFocus
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <LabeledInput
                label={t('COMMON.DEPOSIT_ACCOUNT')}
                {...register('depositAccount')}
                onBlur={(e) => handleMinValue(e, 'depositAccount')}
                type="number"
                selectOnFocus
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <LabeledInput
                label={t('COMMON.SUBSTITUTE_ACCOUNT_VAT_CONVERSION')}
                {...register('substituteAccountVatConversion')}
                onBlur={(e) =>
                  handleMinValue(e, 'substituteAccountVatConversion')
                }
                type="number"
                selectOnFocus
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack>
            <ControllerPlus
              control={control}
              name="isAutomationAccount"
              render={({ field: { value: checked, ...field } }) => {
                return (
                  <CheckboxRadioItem
                    control="checkbox"
                    label={t('COMMON.AUTOMATIC_ACCOUNT')}
                    checked={checked}
                    defaultChecked={checked}
                    {...field}
                  />
                );
              }}
            />
            <ControllerPlus
              control={control}
              name="notDeminishingTurnover"
              render={({ field: { value: checked, ...field } }) => {
                return (
                  <CheckboxRadioItem
                    control="checkbox"
                    label={t('COMMON.NOT_DEMINISHING_TURNOVER')}
                    checked={checked}
                    defaultChecked={checked}
                    {...field}
                  />
                );
              }}
            />
            <ControllerPlus
              control={control}
              name="withoutTaxKey"
              render={({ field: { value: checked, ...field } }) => {
                return (
                  <CheckboxRadioItem
                    control="checkbox"
                    label={t('COMMON.WITHOUT_TAXKEY')}
                    checked={checked}
                    defaultChecked={checked}
                    {...field}
                  />
                );
              }}
            />
            <ControllerPlus
              control={control}
              name="disabled"
              render={({ field: { value: checked, ...field } }) => {
                return (
                  <CheckboxRadioItem
                    control="checkbox"
                    label={t('COMMON.DISABLED')}
                    checked={checked}
                    defaultChecked={checked}
                    {...field}
                  />
                );
              }}
            />
          </Stack>
        </Grid>
      </Grid>
    </Collapse>
  );
}
